import { Tooltip, IconButton } from '@mui/material';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/Edit';
import PropTypes from 'prop-types';

const CRUDActions = ({ onDelete, onEdit, showDelete = true, showEdit = true }) => {
  return (
    <>
      {showDelete && (
        <Tooltip title="Delete">
          <IconButton onClick={onDelete}>
            <DeleteForeverIcon style={{ color: '#800000' }} />
          </IconButton>
        </Tooltip>
      )}

      {showEdit && (
        <Tooltip title="Update">
          <IconButton onClick={onEdit}>
            <EditIcon style={{ color: '#040273' }} />
          </IconButton>
        </Tooltip>
      )}
    </>
  );
};

CRUDActions.propTypes = {
  onDelete: PropTypes.func,
  onEdit: PropTypes.func,
  showDelete: PropTypes.bool,
  showEdit: PropTypes.bool
};

export default CRUDActions;
